import state from './moduleChatTicketCostsState'
import actions from './moduleChatTicketCostsActions'
import getters from './moduleChatTicketCostsGetters'
import mutations from './moduleChatTicketCostsMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
